import Amplify, { Auth } from 'aws-amplify';
import { PROPERTY_SERVICE_V0_AWS_CONFIG } from '../env/Configurations';

Amplify.configure({
  ...PROPERTY_SERVICE_V0_AWS_CONFIG,
});

export async function signIn(username, password) {
  return await Auth.signIn(username, password);
}

export async function signOut() {
  await Auth.signOut({ global: true });
}

export async function setNewPassword(user, newPassword) {
  return await Auth.completeNewPassword(user, newPassword);
}

export async function changePassword(oldPassword, newPassword) {
  const user = await checkAuthState();
  return await Auth.changePassword(user, oldPassword, newPassword);
}

export async function forgotPassword(username) {
  return await Auth.forgotPassword(username);
}

export async function forgotPasswordSubmit(email, code, new_password) {
  const username = String(email).toLowerCase();
  return await Auth.forgotPasswordSubmit(username, code, new_password);
}

export const checkAuthState = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user;
  } catch (e) {
    return null;
  }
};